import { fetcher } from '@/api/fetcher/fetcher'

function fetchMembersSearch({ queryKey }) {
  const query = queryKey[1].reactiveSearch
  return fetcher({
    url: `/member/search`,
    options: { method: 'GET', searchParams: { query } },
  })
}

export { fetchMembersSearch }
